export enum WatchlistView {
  Default = 'Default',
  Watchlist = 'Watchlist',
  Portfolio = 'Portfolio'
}

export const WATCHLIST_ITEMS_MAX_PAGE_SIZE = 2_147_483_647;

// 27 - Popular US Stocks
// 28 - Top Singapore Stocks
// 29 - Popular ETFs
export const DEFAULT_THEMATIC_WATCHLISTS = [27, 28, 29];
